<template>
    <transition name="fade">
        <div>
            <div class="row justify-content-center">
                <div class="col-lg-10 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title bold">Preview of Attachments</h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-success2" role="alert">
                                <p class="fs-15 p-0 m-0 bold">Supported File Format for the following:</p>
                                <div class="row mb-2">
                                    <div class="col-xs-12 col-sm-7">
                                        <p class="p-0 m-0 fs-13">
                                            <span class="badge badge-pill badge-primary">IMG</span> - images [.jpeg, .jpg, .png] [max-size: <b>10MB</b>]
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-5">
                                        <p class="p-0 m-0 fs-13">
                                            <span class="badge badge-pill badge-danger">PDF</span> - [.pdf] [max-size: <b>10MB</b>]
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-12">
                                        <p class="p-0 m-0 fs-13">
                                            <span class="badge badge-pill badge-info">VIDEO</span> - [.mp4, .avi, .flv, .3ggp, .3gp, .wmv, .mov] [max-size: <b>110MB</b>]
                                        </p>
                                    </div>
                                </div>
                                <p class="fs-15 p-0 m-0 bold">Click the info icon <i class="btn-i fas fa-info-circle"></i> to show description/s of the Documentary Requirements.</p>
                            </div>

                            <div class="alert alert-info2" v-if="docs[16].required">
                                <p class="text-justify m-0 p-0 fs-15">Please include as part of the video and pictures a proof that these were recorded/captured within 1 week of the application date (e.g. applicant holding the newspaper of the day showing the date, web/screen capture of official government websites showing the date and time stamps)</p>
                            </div>


                            <div class="table-responsive tableFixHead mb-n2">
                                <table class="table table-bordered table-sm fs-15">
                                    <thead>
                                        <tr>
                                            <th>Documentary Requirements</th>
                                            <th>Format</th>
                                            <th>Status</th>
                                            <th>Details</th>
                                            <th width="5%">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="doc in docs" :key="doc.code" v-if="doc_req(doc)">
                                            <td>
                                                <span>{{doc.label}}<sup @click="showGuide(doc.code)"><i class="btn-i fas fa-info-circle"></i></sup></span>
                                            </td>
                                            <td class="fs-13 align-middle text-center">
                                                <span v-if="doc.sup=='IMG-PDF'">
                                                    <span class="badge badge-pill badge-primary">IMG</span>&nbsp;<span class="badge badge-pill badge-danger">PDF</span>
                                                </span>
                                                <span v-else :class="badgeColor(doc.sup)">{{doc.sup}}</span>
                                            </td>
                                            <td class="align-middle">
                                                <span class="badge" :class="doc.status">{{attStat(doc.status)}}</span>
                                            </td>
                                            <td class="fs-13 align-middle nowrap">
                                                <div v-if="progress[doc.code]">
                                                    <div class="progress">
                                                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress[doc.code]+ ';'">
                                                            {{progress[doc.code]}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <p class="mb-0 pb-0">
                                                        {{doc.details.file}}
                                                    </p>
                                                    <p class="mb-0 pb-0" v-for="x in doc.details.mark" v-if="doc.details.mark.length">
                                                        <span class="text-muted">{{x}}</span>
                                                    </p>
                                                </div>
                                            </td>
                                            <td class="align-middle nowrap">
                                                <input type="file" hidden :id="doc.code" :accept="doc.accept" @change="uploadAttach($event, doc)">
                                                <template v-if="!doc.details.file">
                                                    <button class="btn btn-outline-primary btn-sm" @click="attaching(doc)">Attach</button>
                                                </template>
                                                <template v-else>
                                                    <button class="btn btn-sm btn-outline-primary" @click="attaching(doc)">Change</button>
                                                    <button class="btn btn-sm btn-outline-primary ml-1" @click="viewATT(formATT[doc.code], doc.label, fetchATT[doc.code])">View</button>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>



                            <p class="fs-15"><em>Note: Upon clicking <b>"Start upload"</b>, selected documents will be uploaded and saved. You can also replace/change uploaded documents if needed.</em></p>
                            <button class="btn btn-sm btn-success" @click="btnUpload()"><i class="fas fa-upload mr-1"></i>Start Upload</button>
                        </div>

                        <div class="card-footer">
                            <button class="btn btn-primary" @click="btnBack()"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                            <button class="btn btn-primary float-right" @click="btnNext()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                        </div>
                    </div>
                </div>
            </div>

            <modal-file :attachFile="attachFile" />
            <modal-guide :guidelines="guidelines" ref="modalGuide" />
            <modal-gov-id :formGovID="formGovID" :ref_gov_id="ref_gov_id" :fetchATT='fetchATT' :formATT="formATT" :progress="progress" :attachFile='attachFile' @cancel="getAttID(2)" @attachID="uploadAttach($event, docs.find(item => item.code === 'ATT12'))" />
            <modal-bus-reg :formLoan="formLoan" :fetchATT='fetchATT' :formATT="formATT" :docs="docs" :progress="progress" ref="modalBusReg" @attach="uploadAttach($event, docs.find(item => item.code === bus_reg))" :attachFile='attachFile' />
            <modal-bank :formLoan="formLoan" :fetchATT='fetchATT' :formATT="formATT" :docs="docs" :progress="progress" :attachFile='attachFile' ref="modalBank" @attach="uploadAttach($event, docs.find(item => item.code === 'ATT115'))" />
            <modal-cob :formCob="formCob" :ref_gov_id="ref_gov_id" :ref_cob_rel='ref_cob_rel' :fetchATT='fetchATT' :formATT="formATT" :docs="docs" :progress="progress" :attachFile='attachFile' ref="modalCob" @attach="uploadAttach($event, docs.find(item => item.code === 'ATT29'))" />
            <modal-part-corp :formLoan="formLoan" :fetchATT='fetchATT' :formATT="formATT" :docs="docs" :progress="progress" ref="modalPartCorp" @attach="uploadAttach($event, docs.find(item => item.code === part_corp))" :attachFile='attachFile' />
        </div>
    </transition>
</template>
<script>
    import ModalFile from './ModalFile.vue';
    import ModalGovID from './ModalGovID.vue';
    import ModalBusReg from './ModalBusReg.vue';
    import ModalBank from './ModalBank.vue';
    import ModalGuide from './ModalGuide.vue';
    import ModalCob from './ModalCob.vue';
    import ModalPartCorp from './ModalPartCorp.vue';



    //built-in jsons
    import suffix from '../../../json/suffix.json';
    import req_docs from '../../../json/req_docs.json';
    import sup_file from '../../../json/sup_file.json';
    import stat_upload from '../../../json/stat_upload.json';
    import guidelines from '../../../json/guidelines.json';

    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';


    export default {
        props: ['formLoan', 'user'],
        components: {
            'modal-file': ModalFile,
            'modal-gov-id': ModalGovID,
            'modal-bus-reg': ModalBusReg,
            'modal-bank': ModalBank,
            'modal-guide': ModalGuide,
            'modal-cob': ModalCob,
            'modal-part-corp': ModalPartCorp,
        },
        data() {
            let birATT = [];
            let mapATT = req_docs.map(i => i.code);
            let attaches = mapATT.filter(i => i !== 'ATT12' && i !== 'ATT29');
            // let mergeATT = [...mapATT, ...birATT];
            let propATT = mapATT.reduce((acc, curr) => (acc[curr] = null, acc), {});

            return {

                // mergeATT: mergeATT,
                // birs: [...birATT],

                attaches: [...attaches],
                // docs: [...req_docs],
                docs: JSON.parse(JSON.stringify(req_docs)),
                stat: [...stat_upload],
                supFile: [...sup_file],
                guidelines: [...guidelines],

                progress: {
                    ...propATT
                },
                formATT: {
                    ...propATT
                },
                fetchATT: {
                    ...propATT
                },
                attachFile: {
                    url: null,
                    type: null,
                    name: null
                },
                res_arr: [],
                ref_gov_id: [],
                ref_cob_rel: [],
                formGovID: {
                    borrower_id: null,
                    expiry_date: null,
                    id_code: null,
                    id_number: null,
                    issue_date: null,
                    id_name: null,
                },

                bus_reg: null,
                part_corp: null,
                formCob: {
                    application_id: null,
                    borrower_id: null,
                    fname: null,
                    mname: null,
                    lname: null,
                    suffix_code: null,
                    relation_code: null,
                    id_number: null,
                    id_code: null,
                    date_birth: null,
                },
            }
        },

        validations: {
            formATT: {
                ATT12: {
                    required: requiredIf(function() {
                        return this.req_if('ATT12')
                    })
                },
                ATT102: {
                    required: requiredIf(function() {
                        return this.req_if('ATT102')
                    })
                },
                ATT103: {
                    required: requiredIf(function() {
                        return this.req_if('ATT103')
                    })
                },
                ATT117: {
                    required: requiredIf(function() {
                        return this.req_if('ATT117')
                    })
                },
                ATT118: {
                    required: requiredIf(function() {
                        return this.req_if('ATT118')
                    })
                },
                ATT106: {
                    required: requiredIf(function() {
                        return this.req_if('ATT106')
                    })
                },
                ATT105: {
                    required: requiredIf(function() {
                        return this.req_if('ATT105')
                    })
                },
                ATT107: {
                    required: requiredIf(function() {
                        return this.req_if('ATT107')
                    })
                },
                ATT108: {
                    required: requiredIf(function() {
                        return this.req_if('ATT108')
                    })
                },
                ATT109: {
                    required: requiredIf(function() {
                        return this.req_if('ATT109')
                    })
                },
                ATT110: {
                    required: requiredIf(function() {
                        return this.req_if('ATT110')
                    })
                },
                ATT111: {
                    required: requiredIf(function() {
                        return this.req_if('ATT111')
                    })
                },
                ATT112: {
                    required: requiredIf(function() {
                        return this.req_if('ATT112')
                    })
                },
                ATT08: {
                    required: requiredIf(function() {
                        return this.req_if('ATT08')
                    })
                },
                ATT09: {
                    required: requiredIf(function() {
                        return this.req_if('ATT09')
                    })
                },
                ATT10: {
                    required: requiredIf(function() {
                        return this.req_if('ATT10')
                    })
                },
                ATT113: {
                    required: requiredIf(function() {
                        return this.req_if('ATT113')
                    })
                },
                ATT115: {
                    required: requiredIf(function() {
                        return this.req_if('ATT115')
                    })
                },
                ATT119: {
                    required: requiredIf(function() {
                        return this.req_if('ATT119')
                    })
                },
                ATT120: {
                    required: requiredIf(function() {
                        return this.req_if('ATT120')
                    })
                },
                ATT121: {
                    required: requiredIf(function() {
                        return this.req_if('ATT121')
                    })
                },
                ATT122: {
                    required: requiredIf(function() {
                        return this.req_if('ATT122')
                    })
                },
                ATT123: {
                    required: requiredIf(function() {
                        return this.req_if('ATT123')
                    })
                },
                ATT29: {
                    required: requiredIf(function() {
                        return this.req_if('ATT29')
                    })
                },
                ATT125: {
                    required: requiredIf(function() {
                        return this.req_if('ATT125')
                    })
                },
                ATT126: {
                    required: requiredIf(function() {
                        return this.req_if('ATT126')
                    })
                },
                ATT127: {
                    required: requiredIf(function() {
                        return this.req_if('ATT127')
                    })
                },

                ATT129: {
                    required: requiredIf(function() {
                        return this.req_if('ATT129')
                    })
                },
                ATT104: {
                    required: requiredIf(function() {
                        return this.req_if('ATT104')
                    })
                },
            },
        },
        created() {
            this.evalRequirement();

            Fire.$on('getAttLoanReq', () => {
                this.getAttLoanReq();
            });
            Fire.$on('evalRequirement', () => {
                this.evalRequirement();
            });
        },
        methods: {
            doc_bir(doc) {
                let arr = ['ATT129', 'ATT104', 'ATT103']
                if (doc.required == true && arr.includes(doc.code)) {
                    return true;
                } else {
                    return false;
                }
            },

            doc_req(doc) {
                let arr = ['ATT129', 'ATT104', 'ATT103']
                if (doc.required == true && !arr.includes(doc.code)) {
                    return true;
                } else {
                    return false;
                }
            },

            deleteATT() {
                this.$parent.payloading = true;
                axios.post('/api/v2-del-loan-app-att', {
                  
                            application_id: this.formLoan.application_id,
                            attachment_code: this.attaches
                    
                    })
                    .then(res => {
                        this.$parent.payloading = false;
                        this.$parent.updateStep(3, 'S3Q2');
                    }).catch(err => {
                        this.$parent.payloading = false;
                    })
            },

            btnBack() {
                Swal.fire({
                    title: 'Reminder',
                    icon: 'warning',
                    html: '<p class="fs-18">If you click <b>Yes</b> all uploaded documents will be deleted and you will have to reupload it again.</p>' +
                        '<p class="fs-18">Click <b>No</b> to continue uploading your documents.</p>',
                    icon: 'info',
                    showCancelButton: true,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    allowEnterKey: false,
                    cancelButtonText: 'No',
                    confirmButtonText: 'Yes'
                }).then((result) => {
                    if (result.value) {
                        this.deleteATT();
                    }
                })
            },

            showGuide(e) {
                setTimeout(() => {
                    this.$refs.modalGuide.getGuide(e)
                    $('#modalGuide').modal('show');
                }, 333);
            },


            convertDate(date, e) {
                let front = 'MM/DD/YYYY';
                let back = 'YYYY-MM-DD';
                if (e == 'server') {
                    return date ? moment(date, front).format(back) : null;
                }
                if (e == 'client') {
                    return date ? moment(date, back).format(front) : null;
                }
            },
            swalRequired() {
                Swal.fire({
                    icon: 'warning',
                    text: 'Please complete all required documents before submitting',
                    title: 'Reminder',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },

            async changeGovID() {
                let x = await this.getRefID();
                if (x == 200) {
                    this.viewFetch(this.fetchATT.ATT12, null, '#modalGovID', 2);
                }
            },

            getRefID() {
                if (!this.ref_gov_id.length) {
                    this.$parent.payloading = true;
                    return axios.get('/api/v2-ref-id')
                        .then(res => {
                            this.ref_gov_id = res.data.detail
                            this.$parent.payloading = false;
                            return res.status
                        })
                        .catch(err => {
                            this.$parent.payloading = false;
                            return err.response.status
                        })
                } else return 200;
            },


            getRefCobRel() {
                if (!this.ref_cob_rel.length) {
                    this.$parent.payloading = true;
                    return axios.get('/api/v2-ref-cob-rel')
                        .then(res => {
                            this.ref_cob_rel = res.data.cob_relation
                            this.$parent.payloading = false;
                            return res.status
                        })
                        .catch(err => {
                            this.$parent.payloading = false;
                            return err.response.status
                        })
                } else return 200;
            },



            async changeCob() {
                let x = await this.getRefID();
                let y = await this.getRefCobRel();
                if (x == 200 && y == 200) {
                    $('#modalCob').modal('show');
                }
            },

            req_if(key) {
                // let arr = [...this.docs, ...this.birs];
                let x = this.docs.find(i => i.code === key);
                if (!this.fetchATT[key] && x.required) {
                    return true;
                }
                return false;
            },
            async submitNext() {
                await this.uploading();
                let res = this.res_arr.indexOf(500) !== -1; //check array of uploads where status not equal to 500 (server error)
                if (!res) {
                    this.$parent.updateStep(4, 'S4Q2');
                }
            },

            btnNext: _.debounce(function() {
                this.$v.formATT.$touch();
                if (this.$v.formATT.$invalid) {
                    this.swalRequired();
                } else {
                    this.submitNext();
                }
            }, 333),
            btnUpload: _.debounce(function() {
                this.uploading();
            }, 333),
            async uploading() {
                this.res_arr.splice(0, this.res_arr.length);
                for (let key in this.formATT) {
                    if (this.formATT[key]) {
                        this.$parent.payloading = true;
                        const config = {
                            headers: {
                                'content-type': 'multipart/form-data',
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                            },
                            onUploadProgress: function(progressEvent) {
                                this.progress[key] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                            }.bind(this)
                        }
                        let formData = new FormData();
                        formData.append('borrower_id', this.formLoan.borrower_id);
                        formData.append('application_id', this.formLoan.application_id);
                        formData.append('upload_file', this.formATT[key]);
                        formData.append('attach_code', key);

                        await axios.post('/api/v2-upload-attachments', formData, config)
                            .then(res => {
                                let data = res.data.attached;
                                if (data) {
                                    let x = this.docs.find(i => i.code === key);
                                    x.status = data.status;
                                    x.details['file'] = data.attach.slice(9);
                                    this.formATT[key] = null;
                                    this.fetchATT[key] = data.filepath + data.attach;
                                    this.progress[key] = 0;
                                }
                                this.res_arr.push(res.status);
                                this.$parent.payloading = false;
                            }).catch(err => {
                                this.$parent.payloading = false;
                                this.res_arr.push(err.response.status);
                            })
                    }
                }
            },
            viewFetch(filename, title, modal, mode = 1) {
                this.$parent.payloading = true;
                axios.get('/api/v2-files', {
                        params: {
                            filename: filename,
                        },
                        responseType: 'blob'
                    })
                    .then(response => {
                        this.$parent.payloading = false;
                        if (response.status == 200) {
                            this.attachFile.url = window.URL.createObjectURL(response.data);
                            this.attachFile.type = this.checkMIME(response.data)
                            this.attachFile.name = filename;
                            this.attachFile.title = title;
                            $(modal).modal('show');
                        }
                        if (response.status == 204) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'File Not Found',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((result) => {
                                if (result.value) {
                                    if (mode = 2) {
                                        $(modal).modal('show');
                                    }
                                }
                            })
                        }
                    })
                    .catch((error) => {
                        this.$parent.payloading = false;
                    })
            },
            viewATT(formATT, title, fetchATT) {
                if (formATT) {
                    this.viewAttachFile(formATT, title);
                }
                if (fetchATT) {
                    this.viewFetch(fetchATT, title, '#modalFile')
                }
            },
            checkMIME(file) {
                let type_img = ['image/jpeg', 'image/png', 'image/jpg', 'image/JPEG', 'image/PNG', 'image/JPG'];
                let type_pdf = ['application/pdf', 'application/PDF'];
                let type_video = ['video/MOV', 'video/mov', 'video/MPEG4', 'video/mpeg4', 'video/MP4', 'video/mp4', 'video/AVI', 'video/avi',
                    'video/WMV', 'video/wmv', 'video/MPEGPS', 'video/mpegps', 'video/FLV', 'video/flv', 'video/3GPP', 'video/3ggp', 'video/3GP', 'video/3gp', 'video/HEVC',
                    'video/hevc', 'video/WebM', 'video/wbem', 'video/DNxHR', 'video/dnxhr', 'video/ProRes', 'video/prores', 'video/CineForm', 'video/cineform','video/quicktime'
                ];
                if (file['type']) {
                    if (type_img.includes(file['type'])) {
                        return 'img';
                    }
                    if (type_pdf.includes(file['type'])) {
                        return 'pdf';
                    }
                    if (type_video.includes(file['type'])) {
                        return 'video';
                    }
                }
            },
            viewAttachFile(file, title, modal = '#modalFile') {
                this.attachFile.url = window.URL.createObjectURL(file);
                this.attachFile.type = this.checkMIME(file);
                this.attachFile.title = title;
                $(modal).modal('show');
            },
            attStat(id) {
                if (id) {
                    return this.stat.find(i => i.id === id).item;
                }
            },
            badgeColor(e) {
                let img = 'badge badge-pill badge-primary';
                let pdf = 'badge badge-pill badge-danger';
                let video = 'badge badge-pill badge-info';
                if (e == 'IMG') {
                    return img;
                } else if (e == 'PDF') {
                    return pdf;
                } else if (e == 'VIDEO') {
                    return video;
                } else return;
            },
            invalidFile() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'You are attaching unsupported file format',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },
            trimFilename(n, len) {
                let ext = n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase();
                let filename = n.replace('.' + ext, '');
                if (filename.length <= len) {
                    return n;
                }
                filename = filename.substr(0, len) + (n.length > len ? '[-]' : '');
                return filename + '.' + ext;
            },
            uploadAttach($event, att) {
                let key = att.code;
                let file = $event.target.files[0];
                let doc = this.docs.find(i => i.code === key);
                let mark = doc.details['mark'];
                let fileType = this.supFile.find(i => i.sup === att.sup).type;
                let fileSize = this.supFile.find(i => i.sup === att.sup).size;

                if (file) {
                    if (fileType.includes(file['type'])) {
                        if (file.size <= fileSize) {
                            doc.details['file'] = this.trimFilename(file.name, 10);
                            this.formATT[key] = file;
                            this.fetchATT[key] = null;
                            doc.status = 'AS01';
                            if (key == 'ATT12') {
                                this.attachFile.url = window.URL.createObjectURL(file);
                            }
                        } else {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Info',
                                text: 'Exceeded the maximum file size required',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                            });
                            this.formATT[key] = null;
                            doc.details['file'] = null;
                        }
                    } else {
                        this.invalidFile();
                        if (!this.fetchATT[key]) {
                            this.formATT[key] = null;
                            doc.details['file'] = null;
                        }
                    }
                } else {}
            },
            attaching(e) {
                if (e.action == 1) {
                    document.getElementById(e.code).click();
                } else if (e.action == 2) {
                    if (e.code == 'ATT12') {
                        this.changeGovID();
                    }
                    if (e.code == 'ATT119' || e.code == 'ATT120' || e.code == 'ATT121') {
                        this.bus_reg = e.code;
                        this.$refs.modalBusReg.getRegionProvince(e.code)
                        $('#modalBusReg').modal('show');
                    }

                    if (e.code == 'ATT115') {
                        this.$refs.modalBank.getLoanProceeds()
                        $('#modalBank').modal('show');
                    }

                    if (e.code == 'ATT29') {
                        this.changeCob();
                    }
                    if (e.code == 'ATT122' || e.code == 'ATT123') {
                        this.part_corp = e.code;
                        this.$refs.modalPartCorp.getBeneficiary(e.code)
                        $('#modalPartCorp').modal('show');
                    }
                } else {
                    return;
                }
            },
            getAttLoanReq() {
                axios.get('/api/v2-get-attach-b2c', {
                        params: {
                            borrower_id: this.formLoan.borrower_id,
                            application_id: this.formLoan.application_id,
                            attachment_code: this.attaches
                        }
                    })
                    .then(res => {
                        let data = res.data.attach
                        let mapKey = data.map(i => i.attachment_code);

                        let bus_reg_date = this.convertDate(this.formLoan.bus_reg_date, 'client');

                        for (const key of mapKey) {
                            let arr = data.find(item => item.attachment_code === key);
                            let doc = this.docs.find(item => item.code === key);

                            let filepath = arr.filepath;
                            let attach = arr.attach;

                            doc.details['file'] = attach.slice(9);
                            doc.status = 'AS02';
                            this.fetchATT[key] = filepath + '/' + attach;


                            if (key == 'ATT119' || key == 'ATT120' || key == 'ATT121') {
                                let bus_reg_place = this.formLoan.bus_reg_cityname + ', ' + this.formLoan.bus_reg_provincename
                                doc.details['mark'].splice(0, doc.details['mark'].length);
                                doc.details['mark'].push(bus_reg_place, bus_reg_date);
                            }

                            if (key == 'ATT115') {
                                let manner = this.formLoan.manner_rel_desc;
                                let bank = this.formLoan.bankname;
                                let acctno = this.formLoan.acctno;
                                bank = bank ? bank : manner;
                                doc.details['mark'].splice(0, doc.details['mark'].length);
                                doc.details['mark'].push(bank, acctno);
                            }
                        }
                        if (data.length == 0) {
                            let key = 'ATT115'
                            let doc = this.docs.find(item => item.code === key);
                            let manner = this.formLoan.manner_rel_desc;
                            if (this.formLoan.manner_rel == 'PM') {
                                manner = 'PAYMAYA';
                            }
                            if (this.formLoan.manner_rel == 'GC') {
                                manner = 'GCASH';
                            }
                            let bank = this.formLoan.bankname;
                            let acctno = this.formLoan.acctno;
                            bank = bank ? bank : manner;
                            doc.details['mark'].splice(0, doc.details['mark'].length);
                            doc.details['mark'].push(bank, acctno);
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },



            getAttID(e = 1) {
                this.$parent.payloading = true;
                axios.get('/api/v2-gov-id', {
                        params: {
                            borrower_id: this.formLoan.borrower_id,
                            attachment_code: 'ATT12'
                        }
                    })
                    .then(res => {
                        this.formGovID.borrower_id = this.formLoan.borrower_id;
                        let data = res.data
                        let record = data.attach;
                        let doc = this.docs.find(item => item.code === 'ATT12')
                        if (data.gov_id.length > 0) {
                            let mark = data.gov_id[0].id_name + ' | ' + data.gov_id[0].id_number
                            doc.details['mark'].splice(0, doc.details['mark'].length);
                            doc.details['mark'].push(mark);
                            this.formGovID = data.gov_id[0];

                        }
                        if (record) {
                            doc.details['file'] = record.attach.slice(5);
                            doc.status = 'AS02';
                            this.fetchATT.ATT12 = record.filepath + record.attach;
                        }
                        if (e == 1) {
                            this.getAttLoanReq();
                        }
                        this.$parent.payloading = false;
                    })
                    .catch(err => {
                        this.$parent.payloading = false;
                        console.log(err)
                    })
            },



            getCobDetail() {
                this.$parent.payloading = true;
                axios.get('/api/v2-cob-detail', {
                        params: {
                            borrower_id: this.formLoan.borrower_id,
                            application_id: this.formLoan.application_id,
                            attachment_code: 'ATT29'
                        }
                    })
                    .then(res => {
                        let data = res.data
                        let record = data.attach;
                        let doc = this.docs.find(item => item.code === 'ATT29')
                        if (data.cob_detail.length > 0) {
                            let age = moment().diff(data.cob_detail[0].date_birth, 'years');
                            if (age >= 60) {
                                
                            } else {
                                let suffix = data.cob_detail[0].suffix_desc ? data.cob_detail[0].suffix_desc : '';
                                let cob_name = data.cob_detail[0].fname + ' ' + data.cob_detail[0].mname + ' ' + data.cob_detail[0].lname + ' ' + suffix;
                                let cob_id = data.cob_detail[0].id_name + ' | ' + data.cob_detail[0].id_number;
                                doc.details['mark'].splice(0, doc.details['mark'].length);
                                doc.details['mark'].push(cob_name, cob_id);
                                this.formCob = data.cob_detail[0];
                                if(this.formCob.date_birth){
                                    this.formCob.date_birth = moment(this.formCob.date_birth, 'YYYY-MM-DD').format('MM/DD/YYYY');
                                    document.getElementById("cob_bdate").value = this.formCob.date_birth;
                                }
                                if (record) {
                                    doc.details['file'] = record.attach.slice(5);
                                    doc.status = 'AS02';
                                    this.fetchATT.ATT29 = record.filepath + record.attach;
                                }
                            }
                        }
                        this.$parent.payloading = false;

                        this.formCob.borrower_id = this.formLoan.borrower_id;
                        this.formCob.application_id = this.formLoan.application_id;
                    })
                    .catch(err => {
                        this.$parent.payloading = false;
                        console.log(err)
                    })
            },

            evalRequirement() {
                let existing = this.formLoan.existing_borrower;
                let loan_amt = this.formLoan.req_loan_amt * 1;
                this.guidelines[9].title = `Mayor's Permit OR Barangay Micro Business Enterprise (BMBE) Certificate (previous or current year)`;
                this.guidelines[7].title = `Barangay Permit (previous or current year)`;

                this.docs[8].label = `Mayor's Permit OR Barangay Micro Business Enterprise (BMBE) Certificate (previous or current year)`;
                this.docs[10].label = `Barangay Permit (previous or current year)`;
                // this.docs[16].label = `One (1) minute video showing the financial condition and assets of the business`;

                this.getAttID();
                this.docs[0].required = true;
                this.docs[17].required = true;

                let age = moment().diff(this.user.date_birth, 'years');
                if (age >= 65 && this.formLoan.bt_code == 'BT2020001') {
                    this.docs[23].required = true;
                    this.getCobDetail();
                }

                // this.docs[16].required = true;
                this.docs[13].required = true;
                this.docs[14].required = true;
                this.docs[15].required = true;

                if (existing == 0) {
                    switch (this.formLoan.bt_code) {
                        case 'BT2020002':
                            this.docs[21].required = true;
                            this.docs[1].required = true;
                            this.docs[1].label = `Secretary's Certificate or Board Resolution or Partnership Resolution`;
                            break;
                        case 'BT2020004':
                            this.docs[22].required = true;
                            this.docs[1].required = true;
                            this.docs[1].label = `Secretary's Certificate or Board Resolution or Partnership Resolution`;
                            break;
                        case 'BT2020003':
                            this.docs[22].required = true;
                            break;
                        default:
                    }
                    if (loan_amt <= 100000) {
                        this.docs[10].required = true;
                    }
                    if (loan_amt > 100000) {
                        this.docs[8].required = true;
                    }
                    if (loan_amt > 500000) {
                        this.docs[21].action = 2;
                        this.docs[22].action = 2;
                    }
                }

                if (loan_amt >= 500000) {
                    if (this.formLoan.bt_code == 'BT2020001') {
                        this.docs[18].required = true;
                    }
                    if (this.formLoan.bt_code == 'BT2020002') {
                        this.docs[19].required = true;
                    }
                    if (this.formLoan.bt_code == 'BT2020004') {
                        this.docs[19].required = true;
                    }
                    if (this.formLoan.bt_code == 'BT2020003') {
                        this.docs[19].required = true;
                    }
                }

                if (this.formLoan.req_loan_amt==null || this.formLoan.req_loan_amt=='' || this.formLoan.req_loan_amt == 0) {
                    Swal.fire({
                        // title: 'Reminder',
                        title: 'Oops! Something went wrong',
                        icon: 'warning',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        if (result.value) {
                            this.$parent.payloading = true;
                            axios.post('/api/v2-del-loan-app-att', {
                            
                                        application_id: this.formLoan.application_id,
                                        attachment_code: this.attaches
                               
                                })
                                .then(res => {
                                    this.$parent.payloading = false;
                                    this.$parent.updateStep(3, 'S3Q1');
                                }).catch(err => {
                                    this.$parent.payloading = false;
                                })
                        }
                    })
                }
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>
    .btn-i {
        white-space: nowrap;
        display: inline !important;
        color: #007bff;
        font-size: 13px;
        cursor: pointer;
    }

    label {
        font-weight: 400 !important;
    }

    .tableFixHead {
        overflow-y: auto !important;
        /* min-height: 200px !important;
        max-height: 500px !important; */
    }

    .tableFixHead>table>thead tr:nth-child(1) th {
        background-color: white;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        z-index: 5;
        border-bottom: 4px solid white;
    }

    .tableFixHead>table>thead tr:nth-child(2) th {
        background-color: white;
        position: sticky;
        position: -webkit-sticky;
        top: 35px;
        border-top: 0;
        z-index: 5;
        border-top: 1px solid #dee2e6;
    }

    .tableFixHead>table>thead tr th:not(:first-child) {
        border-left: 0;
    }

    .tableFixHead>table>tbody tr td:not(:first-child) {
        border-left: 0;
    }

    .tableFixHead>table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .tableFixHead>table>tbody>tr:not(:first-child)>td {
        border-top: 0;
    }

    .tableFixHead>table>thead tr th:nth-child(1) {
        top: 0;
        left: 0;
        position: sticky;
        z-index: 6;
    }

    .tableFixHead>table>thead>tr:nth-child(2) th:nth-child(1) {
        top: 35px;
        left: 0;
        position: sticky;
        z-index: 6;
    }

    .tableFixHead>table>tbody tr td:nth-child(1) {
        left: 0;
        position: sticky;
        background-color: inherit !important;
        z-index: 4;
    }

    .tableFixHead>table>tbody tr {
        background: #ffffff;
    }
</style>